"use client";
import {useState} from "react";
import {HitoryRoutePlan} from "./leftWidgets/leftHistory";
import {LeftRoutePlan} from "./leftWidgets/leftRoutePlan";
export const RoutesLeftBar = function () {
  const [isHistoryTab, setIsHistoryTab] = useState(false);

  return (
    <>
      {isHistoryTab ? (
        <HitoryRoutePlan setIsHistoryTab={setIsHistoryTab} />
      ) : (
        <LeftRoutePlan setIsHistoryTab={setIsHistoryTab} />
      )}
    </>
  );
};
